import { BaseDb } from "common/BaseDb"

import { FavoriteProjectsSchemaWithId } from "./favoriteProjects.schema"

export class FavoriteprojectDb extends BaseDb<FavoriteProjectsSchemaWithId> {}
const favoriteprojectDb = new FavoriteprojectDb("project/favoriteprojects")
export default favoriteprojectDb
